import React from 'react';
import { shouldShowSoluqrBranding } from '@/lib/menuPlanCapabilities';
import SoluQrLogo from '@/components/SoluQrLogo';

const SoluQRBanner = ({ business }) => {
  if (!shouldShowSoluqrBranding(business)) {
    return null;
  }

  return (
    <div className="w-full bg-[#FF5A00] text-white py-2.5 text-center text-xs mt-8">
      <a
        href="https://soluqr.cl"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center gap-2 hover:underline"
      >
        <SoluQrLogo size="sm" className="!h-7 !w-7 rounded-md shadow-none ring-1 ring-white/25" />
        <span>Crea tu menú en soluqr.cl</span>
      </a>
    </div>
  );
};

export default SoluQRBanner;
